import React from 'react';
import { Box, Title, Text } from '@mantine/core';

export interface EmptyListProps {
  /** Optional override for empty state title */
  title?: string;
  /** Optional override for empty state message */
  message?: string;
}

const DEFAULT_TITLE = 'No trips found';
const DEFAULT_MESSAGE =
  'Start planning your next adventure by creating a new trip!';

const EmptyList: React.FC<EmptyListProps> = ({
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
}) => (
  <Box ta="center" mt="xl">
    <Title order={3} style={{ color: 'var(--mantine-color-dimmed)' }} mb="md">
      {title}
    </Title>
    <Text style={{ color: 'var(--mantine-color-dimmed)' }} mb="lg">
      {message}
    </Text>
  </Box>
);

export default EmptyList;
